export const LEGEND_MARK_WIDTH = 160;
export const LEGEND_MARK_HEIGHT = 16;
export const SYMBOL_SIZE = 12;
export const HORIZONTAL_LEGEND_ROWS = 2;
export const MAX_LEGEND_ENTRIES = 10000;
export const LABEL_LIMIT = '16ch';